import { ThemeProvider } from "@/components/theme-provider";
import { AuthProvider } from "@/auth-provider";
import { Toaster } from "@/components/ui/sonner";
import { LocationProvider } from "@/components/location-provider";
import { UnitProvider } from "@/components/unit-provider";
import { PaletteProvider } from "@/components/palette-provider";

export function Providers({ children }: { children: React.ReactNode }) {
  return (
    <AuthProvider>
      <ThemeProvider
        attribute="class"
        defaultTheme="dark"
        enableSystem={false}
        disableTransitionOnChange
      >
        <PaletteProvider>
          <LocationProvider>
            <UnitProvider>
              {children}
              <Toaster />
            </UnitProvider>
          </LocationProvider>
        </PaletteProvider>
      </ThemeProvider>
    </AuthProvider>
  );
}
